import { debug } from '@/shared/lib';

import {
  DEFAULT_TRANSCRIPTOR_PREFERENCES,
  TRANSCRIPTOR_PREFERENCES_KEY,
  TREATMENT_PROCESSING_MODES,
} from '../config/constants';
import {
  TranscriptorPreferences,
  TreatmentProcessingMode,
} from '../config/types';

const isRecordOf =
  <T>(isItem: (item: unknown) => item is T) =>
  (value: unknown): value is Record<string, T> =>
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    Object.values(value).every(isItem);

const isStringRecord = isRecordOf(
  (item): item is string => typeof item === 'string',
);

const isTreatmentModeRecord = isRecordOf(
  (item): item is TreatmentProcessingMode =>
    TREATMENT_PROCESSING_MODES.some((mode) => mode === item),
);

export const getStoredPreferences = (): TranscriptorPreferences => {
  try {
    const stored = localStorage.getItem(TRANSCRIPTOR_PREFERENCES_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as Partial<TranscriptorPreferences>;
      return {
        ...DEFAULT_TRANSCRIPTOR_PREFERENCES,
        ...parsed,
        templateSeriesIds: Array.isArray(parsed.templateSeriesIds)
          ? parsed.templateSeriesIds
          : [],
        languageByOrganization: isStringRecord(parsed.languageByOrganization)
          ? parsed.languageByOrganization
          : undefined,
        treatmentModeByOrganization: isTreatmentModeRecord(
          parsed.treatmentModeByOrganization,
        )
          ? parsed.treatmentModeByOrganization
          : undefined,
      };
    }
  } catch (error) {
    debug(error);
  }
  return DEFAULT_TRANSCRIPTOR_PREFERENCES;
};
